<template>
  <div class="company-box" v-if="showBox">
    <a
      href="javascript:;"
      @click="showCompanyList"
      class="weui-btn_cell weui-btn_cell-default"
      >{{ company.name }}<span class="iconfont icon-more"></span></a
    >
  </div>
</template>

<script>
import Auth from "@/util/auth.js";
import Session from '@/util/session';

export default {
  data() {
    return {
      account: {
        companyId: null,
        companies: [],
      },
      company: {},
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    showBox() {
      var companies = this.account.companies;
      return companies && companies.length > 1;
    },
  },
  methods: {
    loadData() {
      const me = this;
      Auth.get()
        .then(function (data) {
          let account = data.account;
          me.account = account;
          me.company = me.account.companies.find(
            (item) => item.id == account.companyId
          );
        })
        .catch(function (res) {
          me.$router.push({
            name: "Error",
            params: res,
          });
        });
    },
    showCompanyList() {
      var me = this,
        companyId = me.account.companyId,
        companies = me.account.companies,
        actions = companies.map((company) => {
          return {
            label: company.name,
            value: company.id,
          };
        });
      me.$weui.picker(actions, {
        defaultValue: [companyId],
        onConfirm: function (result) {
          let newCompanyId = result[0].value;
          if (newCompanyId != companyId) {
            me.switchCompany(newCompanyId);
          }
        },
      });
    },
    switchCompany(companyId) {
      const me = this;
      me.$loading({
        url: "/api/auth/switch/company",
        method: "POST",
        params: {
          companyId,
        },
        headers: {
          Authorization: Session.getToken(),
        },
        withCredentials: true,
      }).then(function (res) {
        if (res.success) {
          let token = res.data,
            account = Object.assign(me.account),
            company = account.companies.find(
              (item) => item.id == companyId
            ),
            appId = company.app;
          account.defaultCompany = company;
          Auth.set({
            token,
            appId,
            account,
          });
          me.account.companyId = companyId;
          me.company = company;
        } else {
          me.$weui.topTips("切换失败：" + res.message, 3000);
        }
      });
    },
  },
};
</script>

<style scoped>
.company-box .weui-btn_cell {
    background: var(--weui-BG-0);
}
.company-box .iconfont {
    margin-left: 10px;
}
</style>
